"use client"

import { getFixedT } from "@/languages/i18n"
import { cn } from "@/lib/utils"
import Link from "next/link"
import { useEvents } from "../hooks/useEvents"
import { EventCarousel } from "./EventCarousel"

interface EventCarouselContentProps {
  title?: string
  className?: string
  viewAllUrl?: string
  contentClassName?: string
  locale?: string
}

export const EventCarouselContent = ({ title, className = "", viewAllUrl, contentClassName = "", locale }: EventCarouselContentProps) => {
  const t = getFixedT(locale)
  const { events, loading } = useEvents(10)

  return (
    <div className={className}>
      <div
        className={cn(
          "max-w-[1304px] mx-auto px-4 flex flex-col gap-5 sm:pt-[78px] pt-[54px]",
          contentClassName
        )}
      >
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-[#333333] leading-[37.2px]">{title}</h2>
          <Link href={viewAllUrl || "/"} className="text-base text-[#17A148] leading-[24.8px] hover:text-[#1EAD46]">{t("View all")}</Link>
        </div>
        <EventCarousel events={events} loading={loading} locale={locale} />
      </div>
    </div>
  )
}
